import { createContext, useContext, useState, type ReactNode } from "react";
import type { PostitRecord } from "@/types/api";

interface FloatingPostitContextValue {
  floatingPostit: PostitRecord | null;
  setFloatingPostit: (p: PostitRecord | null) => void;
}

const FloatingPostitContext = createContext<FloatingPostitContextValue>({
  floatingPostit: null,
  setFloatingPostit: () => {},
});

export function FloatingPostitProvider({ children }: { children: ReactNode }) {
  const [floatingPostit, setFloatingPostit] = useState<PostitRecord | null>(null);
  return (
    <FloatingPostitContext.Provider value={{ floatingPostit, setFloatingPostit }}>
      {children}
    </FloatingPostitContext.Provider>
  );
}

export function useFloatingPostit() {
  return useContext(FloatingPostitContext);
}
